import { render, staticRenderFns } from "./check.vue?vue&type=template&id=73d207bb&scoped=true&"
import script from "./check.vue?vue&type=script&lang=js&"
export * from "./check.vue?vue&type=script&lang=js&"
import style0 from "./check.vue?vue&type=style&index=0&id=73d207bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d207bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73d207bb')) {
      api.createRecord('73d207bb', component.options)
    } else {
      api.reload('73d207bb', component.options)
    }
    module.hot.accept("./check.vue?vue&type=template&id=73d207bb&scoped=true&", function () {
      api.rerender('73d207bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/check/check.vue"
export default component.exports